import {
  LanguageTestSection,
  LanguageTestSectionInput
} from '../../lib/types/models/language-test/language-test-section'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const updateLanguageTestSection = ({
  id,
  ...data
}: UpdateInput<LanguageTestSectionInput>) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.updateSection.url, { id }))
    .patch<LanguageTestSection, Partial<LanguageTestSectionInput>>(data)
